module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KNgeVC/tc-custom/9781035814459.jpg?1705766066669",
      "alt": "This image is the cover for the book Metaverse Unfolds"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Metaverse Unfolds\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("As the earth’s environment and ecosystems become increasingly degraded, humans must rely on the advanced technology of the unfolding METAVERSE to survive. In this thrilling and fast-moving novel, we explore the transience of human frailty through themes of lust, jealousy, greed, betrayal, intrigue, murder, and the sacrifice of immortality for love. With the limitations of our current environment, many choose to spend much of their time in virtual reality, where they can enjoy a sense of home, family, and the beauty of nature. However, as millions flock to this virtual world, it becomes increasingly likely that we, and those around us, are simply part of a virtual journey. Will you join us in the METAVERSE?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Val Fernbach\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Valentine Fernbach was born in Budapest in 1942 and emigrated to Australia in 1949. He studied civil engineering and was involved in bridge design and construction. He retired from the Gordon Institute in 1997 where he held the position of Head of Civil Engineering and Building Design. He now lives with his wife, Susan, at Currabilli in Torquay, Victoria where he continues to pursue his writing and illustrations.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0